/** InsCoder WANG.J 2026-08-17 B + Real Results product feature highlights animation lifecycle **/

(function () {
  var selector = '[data-cust-real-results-product-feature-highlights]';
  var instances = new WeakMap();

  /** InsCoder WANG.J 2026-08-18 B + Real Results staggered reveal and parallax intensity **/
  var DESKTOP_PARALLAX_FACTOR = 1080;
  var MOBILE_PARALLAX_FACTOR = 0;
  var PARALLAX_LIMIT = 96;
  var PETAL_FADE_DURATION = 1200;
  /** InsCoder WANG.J 2026-08-18 E + Real Results staggered reveal and parallax intensity **/

  function createPetals(root) {
    var layer = root.querySelector('[data-real-results-petal-layer]');

    if (!layer) {
      return null;
    }

    if (layer.childElementCount) {
      return layer;
    }

    var petalAssets = [
      layer.getAttribute('data-petal-asset-1'),
      layer.getAttribute('data-petal-asset-2'),
      layer.getAttribute('data-petal-asset-3'),
      layer.getAttribute('data-petal-asset-4')
    ].filter(Boolean);

    if (!petalAssets.length) {
      return layer;
    }

    for (var index = 0; index < 12; index += 1) {
      var petal = document.createElement('span');
      var petalImage = document.createElement('img');
      var size = 68 + ((index * 37) % 104);
      var mobileSize = 36 + ((index * 19) % 48);
      var duration = 14 + ((index * 3) % 9);
      var delay = -((index * 1.9) % duration);
      var left = (index * 17.3) % 100;
      var sway = ((index % 2 === 0 ? 1 : -1) * (48 + ((index * 17) % 112)));
      var rotation = (index * 37) % 360;

      petal.className = 'cust-real-results-product-feature-highlights__petal';
      petalImage.className = 'cust-real-results-product-feature-highlights__petal-image';
      petalImage.src = petalAssets[index % petalAssets.length];
      petalImage.alt = '';
      petalImage.decoding = 'async';
      petal.style.setProperty('--real-results-petal-size', size + 'px');
      petal.style.setProperty('--real-results-petal-size-mobile', mobileSize + 'px');
      petal.style.setProperty('--real-results-petal-duration', duration + 's');
      petal.style.setProperty('--real-results-petal-delay', delay + 's');
      petal.style.setProperty('--real-results-petal-left', left + '%');
      petal.style.setProperty('--real-results-petal-sway', sway + 'px');
      petal.style.setProperty('--real-results-petal-rotation', rotation + 'deg');
      petal.appendChild(petalImage);
      layer.appendChild(petal);
    }

    return layer;
  }

  function initialize(root) {
    if (!root || instances.has(root)) {
      return;
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-real-results-card]'));
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var parallaxEnabled = root.dataset.parallaxAnimation === 'true' && !reducedMotion;
    var petalAnimationEnabled = root.dataset.petalAnimation === 'true' && !reducedMotion;
    /** InsCoder WANG.J 2026-08-18 B + Merchant-configurable petal animation duration **/
    var petalHideAfterSeconds = Math.max(0, parseFloat(root.dataset.petalHideAfter || '0') || 0);
    var petalHideTimerId = null;
    var petalStopTimerId = null;
    var petalAnimationExpired = false;
    /** InsCoder WANG.J 2026-08-18 E + Merchant-configurable petal animation duration **/
    var frameId = null;
    var destroyed = false;
    var observers = [];

    root.classList.add('cust-real-results-product-feature-highlights--js-ready');
    var petalLayer = createPetals(root);
    var updatePetalTravel = function () {
      if (petalLayer) {
        petalLayer.style.setProperty(
          '--real-results-petal-travel',
          Math.ceil(root.offsetHeight + (window.innerHeight * 0.24)) + 'px'
        );
      }
    };

    updatePetalTravel();
    window.addEventListener('resize', updatePetalTravel, { passive: true });

    /** InsCoder WANG.J 2026-08-18 B + Hide petals after configured visible duration **/
    var startPetalHideTimer = function () {
      if (petalHideAfterSeconds <= 0 || petalHideTimerId !== null || petalAnimationExpired) {
        return;
      }

      petalHideTimerId = window.setTimeout(function () {
        petalAnimationExpired = true;
        root.classList.add('cust-real-results-product-feature-highlights--petals-hiding');
        petalStopTimerId = window.setTimeout(function () {
          root.classList.remove(
            'cust-real-results-product-feature-highlights--petals-active',
            'cust-real-results-product-feature-highlights--petals-hiding'
          );
        }, PETAL_FADE_DURATION);
      }, petalHideAfterSeconds * 1000);
    };
    /** InsCoder WANG.J 2026-08-18 E + Hide petals after configured visible duration **/

    if (petalAnimationEnabled && typeof IntersectionObserver === 'function') {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !petalAnimationExpired) {
            root.classList.add('cust-real-results-product-feature-highlights--petals-active');
            startPetalHideTimer();
          } else if (!entry.isIntersecting) {
            root.classList.remove(
              'cust-real-results-product-feature-highlights--petals-active',
              'cust-real-results-product-feature-highlights--petals-hiding'
            );
          }
        });
      }, { threshold: 0.05 });

      visibilityObserver.observe(root);
      observers.push(visibilityObserver);
    } else if (petalAnimationEnabled) {
      root.classList.add('cust-real-results-product-feature-highlights--petals-active');
      startPetalHideTimer();
    }

    if (parallaxEnabled && cards.length) {
      var revealCard = function (card) {
        if (!card.classList.contains('is-visible')) {
          card.classList.add('is-visible');
        }
      };

      var revealVisibleCards = function () {
        cards.forEach(function (card) {
          var rect = card.getBoundingClientRect();

          if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
            revealCard(card);
          }
        });
      };

      if (typeof IntersectionObserver === 'function') {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealCard(entry.target);
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });

        cards.forEach(function (card) {
          revealObserver.observe(card);
        });
        observers.push(revealObserver);
      }

      var updateParallax = function () {
        frameId = null;

        if (destroyed) {
          return;
        }

        var viewportCenter = window.innerHeight / 2;
        var parallaxFactor = window.innerWidth <= 768
          ? MOBILE_PARALLAX_FACTOR
          : DESKTOP_PARALLAX_FACTOR;
        revealVisibleCards();

        cards.forEach(function (card) {
          var rect = card.getBoundingClientRect();
          var cardCenter = rect.top + (rect.height / 2);
          var distance = (cardCenter - viewportCenter) / Math.max(window.innerHeight, 1);
          var speed = parseFloat(card.dataset.parallaxSpeed || '0.012');
          var offset = Math.max(
            -PARALLAX_LIMIT,
            Math.min(PARALLAX_LIMIT, distance * speed * -parallaxFactor)
          );

          card.style.setProperty('--real-results-parallax-y', offset.toFixed(2) + 'px');
        });
      };

      var requestParallaxUpdate = function () {
        if (frameId === null) {
          frameId = window.requestAnimationFrame(updateParallax);
        }
      };

      window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate, { passive: true });
      requestParallaxUpdate();

      instances.set(root, function () {
        window.removeEventListener('scroll', requestParallaxUpdate);
        window.removeEventListener('resize', requestParallaxUpdate);
      });
    } else {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      instances.set(root, function () {});
    }

    var cleanup = instances.get(root);
    instances.set(root, function () {
      destroyed = true;
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
      if (petalHideTimerId !== null) {
        window.clearTimeout(petalHideTimerId);
      }
      if (petalStopTimerId !== null) {
        window.clearTimeout(petalStopTimerId);
      }
      observers.forEach(function (observer) {
        observer.disconnect();
      });
      window.removeEventListener('resize', updatePetalTravel);
      cleanup();
    });
  }

  function initializeWithin(scope) {
    if (!scope) {
      return;
    }

    if (scope.matches && scope.matches(selector)) {
      initialize(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(selector).forEach(initialize);
    }
  }

  function initializeAll() {
    document.querySelectorAll(selector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches(selector)
      ? event.target
      : event.target.querySelector
        ? event.target.querySelector(selector)
        : null;
    var cleanup = root && instances.get(root);

    if (cleanup) {
      cleanup();
      instances.delete(root);
    }
  });
})();

/** InsCoder WANG.J 2026-08-17 E + Real Results product feature highlights animation lifecycle **/
